import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import {
	RETIREMENT_ANCHOR_KEYS,
	RETIREMENT_SKELETON_EXPENSE_ROWS,
} from "web_myplann/Inspiration/Retirement/constants";
import { SabSkeleton } from "web_myplann/Shared/Skeletons";

export const RetirementSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack mt={theme.spacingTokens.sm} gap={theme.spacingTokens.sm}>
			<InspirationSection title={<SabSkeleton variant="text" width={180} />}>
				<SabSkeleton
					variant="rounded"
					height={105}
					borderRadius={theme.radii.lg}
				/>
			</InspirationSection>

			<InspirationSection
				title={<SabSkeleton variant="text" width={210} />}
				gap={theme.spacingTokens.md}
			>
				{RETIREMENT_SKELETON_EXPENSE_ROWS.map((row) => (
					<SabSkeleton
						key={row}
						variant="rounded"
						height={44}
						borderRadius={theme.radii.lg}
					/>
				))}
			</InspirationSection>

			<InspirationSection
				title={<SabSkeleton variant="text" width={150} />}
				gap={theme.spacingTokens.md}
			>
				<Stack direction="row" gap={theme.spacingTokens.sm}>
					{RETIREMENT_ANCHOR_KEYS.map((key) => (
						<SabSkeleton
							key={key}
							variant="rounded"
							height={105}
							borderRadius={theme.radii.lg}
							sx={{ flex: 1 }}
						/>
					))}
				</Stack>
				<SabSkeleton
					variant="rounded"
					height={105}
					borderRadius={theme.radii.lg}
				/>
			</InspirationSection>
		</Stack>
	);
};
